import { Button, Form, Popup } from 'devextreme-react';
import { useScreenSize } from '../../../utils/media-query';
import { Item, Label } from 'devextreme-react/form';
import { ToolbarItem } from 'devextreme-react/popover';
import { useCallback, useMemo, useRef } from 'react';
import { EMonitoreoServiciosMasivos } from '../../../types/types.monitoreo';
import { useAppSelector } from '../../../contexts/hooks';
import { selectModuleEmail, selectModuleExternalRemissions, selectModuleWhatsApp } from '../../../contexts/selectors';

const FieldsToFilters: {
  Mtsm_Fecha: Date[];
  Mtsm_Estado: boolean | null;
  Mtsm_Tipo: EMonitoreoServiciosMasivos | null;
} = {
  Mtsm_Fecha: [new Date(), new Date()],
  Mtsm_Estado: null,
  Mtsm_Tipo: null,
};

const LstEstados = [
  { Id: false, Nombre: 'Error' },
  { Id: true, Nombre: 'Correcto' },
];

export const ModalFilter = ({ visible, handleApplyFilter, handleCancelFilter }) => {
  const { isXSmall } = useScreenSize();
  const frmRef = useRef<Form>(null);
  const moduleEmail = useAppSelector(selectModuleEmail);
  const moduleWhatsApp = useAppSelector(selectModuleWhatsApp);
  const moduleExternalRemissions = useAppSelector(selectModuleExternalRemissions);

  const LstTipos = useMemo(() => {
    const tipos: { Id: EMonitoreoServiciosMasivos; Nombre: string }[] = [];
    if (moduleEmail) tipos.push({ Id: EMonitoreoServiciosMasivos.Email, Nombre: 'Envío masivo de correo' });
    if (moduleWhatsApp) tipos.push({ Id: EMonitoreoServiciosMasivos.WhatsApp, Nombre: 'Envío masivo por WhatsApp' });
    if (moduleExternalRemissions) tipos.push({ Id: EMonitoreoServiciosMasivos.RemisionExterna, Nombre: 'Envío masivo de remisiones' });
    return tipos;
  }, [moduleEmail, moduleWhatsApp, moduleExternalRemissions]);

  const handleCancel = useCallback(() => {
    frmRef.current?.instance.resetValues();
    handleCancelFilter();
  }, [FieldsToFilters]);

  const handleConfirm = useCallback(() => {
    if (frmRef.current?.instance) {
      if (!frmRef.current.instance.validate().isValid) {
        return;
      }
      handleApplyFilter(FieldsToFilters);
    }
  }, [FieldsToFilters]);

  return (
    <Popup height='auto' title='Filtrar tareas masivas' fullScreen={isXSmall} hideOnOutsideClick={true} width={500} visible={visible} dragEnabled={true} showTitle={true}>
      <Form ref={frmRef} formData={FieldsToFilters}>
        <Item dataField='Mtsm_Fecha' isRequired editorType='dxDateRangeBox' editorOptions={{ displayFormat: 'shortdate' }}>
          <Label text='Fecha' />
        </Item>
        <Item dataField='Mtsm_Estado' editorType='dxSelectBox' editorOptions={{ dataSource: LstEstados, showClearButton: true, displayExpr: 'Nombre', valueExpr: 'Id' }}>
          <Label text='Estado' />
        </Item>
        <Item dataField='Mtsm_Tipo' editorType='dxSelectBox' editorOptions={{ dataSource: LstTipos, showClearButton: true, displayExpr: 'Nombre', valueExpr: 'Id' }}>
          <Label text='Tipo' />
        </Item>
      </Form>
      <ToolbarItem toolbar='bottom' location='after'>
        <div className={`form-popup-buttons-container`}>
          <Button text='Cancelar' stylingMode='contained' onClick={handleCancel} />
          <Button text='Confirmar' stylingMode='contained' type='default' onClick={handleConfirm} />
        </div>
      </ToolbarItem>
    </Popup>
  );
};
